import type { NewsItem } from '../types/news';

export function htmlToParagraphs(html: string): string[] {
    if (!html) return [];

    const container = document.createElement('div');
    container.innerHTML = html;

    const blocks = container.querySelectorAll('p, li, h1, h2, h3, h4');

    const paragraphs = Array.from(blocks)
        .map((node) => (node.textContent ?? '').replace(/\u00a0|\ufeff/g, ' ').trim())
        .filter((text) => text !== '');

    // Текст без блочных тегов — вернём одной строкой
    if (paragraphs.length === 0) {
        const flat = (container.textContent ?? '').trim();
        return flat ? [flat] : [];
    }

    return paragraphs;
}

export function paragraphsToHtml(text: string): string {
    return text
        .split(/\n{2,}/)
        .map((block) => block.trim())
        .filter(Boolean)
        .map((block) => `<p>${escapeHtml(block).replace(/\n/g, '<br>')}</p>`)
        .join('');
}

function escapeHtml(text: string): string {
    return text
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');
}

export function htmlToPlainText(html: string): string {
    return htmlToParagraphs(html).join('\n\n');
}

export function isGreeting(paragraph: string): boolean {
    return /^уважаем/i.test(paragraph.trim());
}

export function isSignature(paragraph: string): boolean {
    return /^с уважением/i.test(paragraph.trim());
}

export function getSnippet(item: NewsItem): string {
    const meaningful = item.paragraphs.find(
        (paragraph) => !isGreeting(paragraph) && !isSignature(paragraph),
    );

    return meaningful ?? item.paragraphs[0] ?? '';
}